import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent {
  type: 'expired' | 'invalid' | string = 'invalid';
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.type = this.route.snapshot.queryParamMap.get('type') || 'invalid';
  }
}
